import useWeb3UserAddress from "@/hooks/web3/useWeb3UserAddress";
import type { SupWeb3Address, SupWeb3VaultBalance } from "@/types";

import { useMemo } from "react";
import useApi from "@/hooks/api/useApi";

export type SupTransmuteType = "1155A" | "ERC20";

export interface ResponseErc20Transmute {
  to: SupWeb3Address;
  data: string;
  method: string;
}

/**
 * @package api:go
 * @link https://superform-xyz.postman.co/workspace/Superform~fe57d318-f198-4f97-9c50-0b2a5a78dbac/request/3472327-6fc1e632-adf5-4608-9864-fd6ce8257e35?action=share&source=copy-link&creator=26633220&active-environment=9faa12dd-452a-4b02-81a7-eced0431d716
 * @link https://superform-xyz.postman.co/workspace/Superform~fe57d318-f198-4f97-9c50-0b2a5a78dbac/request/3472327-7cd72dbb-d5b9-4046-9597-bb0f79adbbb8?action=share&source=copy-link&creator=26633220&active-environment=9faa12dd-452a-4b02-81a7-eced0431d716
 */
export default function useErc20Transmute(to: SupTransmuteType, superPosition: SupWeb3VaultBalance | undefined = undefined, amount: string | undefined = undefined) {
  const userAddress = useWeb3UserAddress();

  const queryParams = useMemo(
    () => ({
      to,
      user_address: userAddress,
      chain_id: superPosition?.chain_id,
      superform_id: superPosition?.vault.superform_id,
      amount: amount ? amount : superPosition?.superposition_balance,
    }),
    [to, userAddress, superPosition?.chain_id, superPosition?.vault.superform_id, superPosition?.superposition_balance, amount]
  );

  const enabled = useMemo(() => Boolean(to) && Boolean(superPosition), [to, superPosition]);

  console.log("making transmute call", { to, superPosition, queryParams, enabled });

  const { data, error, isLoading, isError, mutate } = useApi<ResponseErc20Transmute, ResponseErc20Transmute | "">(
    {
      path: "/erc20/transmute/",
      api: "v2",
      params: queryParams,
    },
    {
      enabled: enabled,
      strategy: "default",
      select: data => {
        if (data === "") {
          throw new Error("API response is empty, please report this issue to the support team");
        }
        return data;
      },
    }
  );

  return {
    data,
    error,
    isLoading,
    isError,
    mutate,
  };
}
